<template>
  <div class="warnings">
    <component
      v-if="renderKey"
      :is="currentComponent"
      :toggleComponent="toggleComponent"
      :currentWarningContentType="currentWarningContentType"
      :warningMenus="warningMenus"
      :setCurrentWarningContentType="setCurrentWarningContentType"
    />
  </div>
</template>

<script>
import WarningType from "./components/WarningType"
import WarningContent from "./components/WarningContent"

import { getMenusOfCurrentUser } from "@/api/auth/menu"

export default {
  data() {
    return {
      WarningType,
      WarningContent,
      currentComponent: null,
      currentWarningContentType: {},
      warningMenus: [],
      defaultDeviceCode: "",
      renderKey: true
    }
  },
  created() {
    const deviceCode = localStorage.getItem("deviceCode")
    const warningType = localStorage.getItem("targetWarningType")
    if (deviceCode && warningType) {
      this.showWarningContent(deviceCode, warningType)
    } else {
      this.currentComponent = WarningType
    }
  },
  methods: {
    toggleComponent(target, type, menus) {
      this.currentWarningContentType = type
      this.currentComponent = this[target]
      this.warningMenus = menus
    },
    async showWarningContent(c, t) {
      await this.setWarningMenus()
      const target = this.warningMenus.find(w => w.routeName === t)
      if (target) {
        this.currentWarningContentType = target
        this.currentComponent = WarningContent
      } else {
        this.currentComponent = WarningType
      }
    },
    async setWarningMenus() {
      const warningTypes = await this.requestWarningMenus()

      const i = warningTypes.findIndex(w => w.routeName === "WarningOrder")
      if (i > -1) {
        warningTypes.splice(i, 1)
      }

      this.warningMenus = warningTypes
        .map(w => {
          (w.details || []).forEach(d => {
            w[d.locale] = d.name
          })
          w.name = w["zh-CN"]

          return w
        })
    },
    async requestWarningMenus() {
      try {
        const { data } = await getMenusOfCurrentUser()
        const menu = data.find(r => r.id === 40)

        return menu.children ?? []
      } catch (e) {
        console.log(e)
        return []
      }
    },
    setCurrentWarningContentType(type) {
      const target = this.warningMenus.find(w => w.routeName === type)
      if (target) {
        this.currentWarningContentType = target
        this.renderKey = false
        this.$nextTick(() => {
          this.renderKey = true
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>